export const SNAP_GRID = 8;
export const CANVAS_PADDING = 20;
export const MIN_WIDGET_GAP = 16;
